export default "__VITE_ASSET__DAD4FJDE__"